module.exports = __webpack_public_path__ + "assets/a429bf3b7e8599cfccccb7f0ec842091.png";